import { FC, useEffect, useState } from 'react';
import { Select, Spin } from 'antd';
import apiRequests from 'utils/api';
import apiRoutes from 'config/apiRoute';
import asyncErrorHandler from 'utils/asyncErrorHandler';

interface RequestsSelectProps {
  projectUuid?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const RequestsSelect: FC<RequestsSelectProps> = ({ projectUuid, value, onChange }) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!projectUuid) return;

    setLoading(true);
    apiRequests
      .get(apiRoutes.REQUESTS, {
        'page[size]': 100,
        'filters[project.uuid][]': projectUuid,
        'filters[projects_requests.status]': [
          'draft', 'new', 'waiting_approval',
          'needs_attention', 'approved', 'in_progress',
        ],
      })
      .then((res) => {
        setOptions(
          res.data.data.map((req: any) => ({
            label: req.subject ?? 'Untitled',
            value: req.uuid,
          }))
        );
      })
      .catch(asyncErrorHandler)
      .finally(() => setLoading(false));
  }, [projectUuid]);

  return (
    <Select
      mode="multiple"
      loading={loading}
      placeholder="Select requests..."
      options={options}
      value={value}
      onChange={onChange}
      notFoundContent={
        loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: 6, alignItems: 'center' }}>
            <Spin size="small" />
            <span>Loading...</span>
          </div>
        ) : undefined
      }
      style={{ width: '100%' }}
      filterOption={(input: any, option: any) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default RequestsSelect;
